import "./App.css";
import { MotionConfig } from "framer-motion";
import { Toaster } from "sonner";
import SmoothScroll from "./components/SmoothScroll";
import Preloader from "./components/Preloader";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import CookieBanner from "./components/CookieBanner";
import Manifesto from "./components/Manifesto";
import EditorialMarquee from "./components/EditorialMarquee";
import Projects from "./components/Projects";
import Services from "./components/Services";
import Style from "./components/Style";
import Why from "./components/Why";
import Faq from "./components/Faq";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import SEO from "./components/SEO";
import GoogleAnalytics from "./components/GoogleAnalytics";
import { CookieIcon } from "lucide-react";

function App() {
  return (
    <>
      <SEO
        title="Web Designer | Michele Rago"
        description="Creo siti web moderni, veloci e ottimizzati SEO per aziende e professionisti."
        url="https://www.micheleragowebdesigner.com"
      />

      <MotionConfig reducedMotion="user">
        <div className="App relative min-h-screen bg-background text-foreground">
          <div className="grain" aria-hidden="true" />

          <SmoothScroll />
          <Preloader />

          <Toaster
            theme="dark"
            position="bottom-right"
            toastOptions={{
              style: {
                background: "hsl(0 0% 8%)",
                border: "1px solid hsl(0 0% 18%)",
                color: "hsl(0 0% 98%)",
                fontFamily: "JetBrains Mono, monospace",
                fontSize: "12px",
              },
            }}
          />

          <Navbar />

          <main>
            <Hero />
            <EditorialMarquee />
            <Manifesto />
            <Projects />
            <Services />
            <Style />
            <Why />
            <Faq />
            <Contact />
          </main>
          <Footer />
          <GoogleAnalytics/>
          <CookieBanner />
        </div>
      </MotionConfig>
    </>
  );
}

export default App;